// extracted by mini-css-extract-plugin
module.exports = {"number-input":"number-input_component_number-input__6v6dg"};